import type { TableProps } from 'antd'
import { Card } from 'antd'
import { Button, Flex, Input, Space, Table, Typography } from 'antd'
import React from 'react'
import MobileButton from '@shared/ui/mobile-button/mobile-button'
import useMobileView from '@shared/hooks/isMobile'

interface DataType {
    key: string
    name: string
    dateRegistration: string
    sum: string
    reward: string
    linkName: string
}

export const Statistics = () => {
    const isMobile = useMobileView()
    const columns: TableProps<DataType>['columns'] = [
        {
            title: 'Имя пользователя',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Дата регистрации',
            dataIndex: 'dateRegistration',
            key: 'dateRegistration'
        },
        {
            title: 'Сумма подписки',
            dataIndex: 'sum',
            key: 'sum'
        },
        {
            title: 'Вознаграждение',
            dataIndex: 'reward',
            key: 'reward'
        },
        {
            title: 'Имя ссылки',
            dataIndex: 'linkName',
            key: 'linkName'
        }
    ]

    const data: DataType[] = [
        // {
        //     key: '1',
        //     name: 'John Brown',
        //     dateRegistration: '1:2:2024',
        //     linkName: 'http://localhost:3000/referral',
        //     sum: '500',
        //     reward: 'вознаграждение'
        // },
        // {
        //     key: '2',
        //     name: 'John Brown',
        //     dateRegistration: '1:2:2024',
        //     linkName: 'http://localhost:3000/referral',
        //     sum: '500',
        //     reward: 'вознаграждение'
        // },
        // {
        //     key: '3',
        //     name: 'John Brown',
        //     dateRegistration: '1:2:2024',
        //     linkName: 'http://localhost:3000/referral',
        //     sum: '500',
        //     reward: 'вознаграждение'
        // }
    ]

    if (isMobile) {
        return (
            <Flex vertical gap={'middle'}>
                <Card style={{ backgroundColor: '#FFFFFF', width: '100%' }}>
                    <Typography.Paragraph style={{ color: '#8F8E94', fontSize: 17, marginBottom: 10 }}>
                        Присвоить имя ссылке
                    </Typography.Paragraph>
                    <Flex vertical gap={17}>
                        <Input
                            style={{
                                padding: '13px 13px',
                                borderRadius: 12,
                                fontSize: 17,
                                color: '#8F8E94',
                                border: 'none'
                            }}
                            placeholder={'Telegaplan'}
                        />
                        <MobileButton>Добавить</MobileButton>
                    </Flex>
                </Card>
                {data.map((item) => {
                    return (
                        <Card style={{ backgroundColor: '#FFFFFF', width: '100%' }}>
                            <Flex justify={'space-between'} align={'center'}>
                                <Typography.Title style={{ color: '#000000', fontSize: 17, margin: 0 }}>
                                    {item.name}
                                </Typography.Title>
                                <Typography.Title style={{ color: '#000000', fontSize: 14, margin: 0 }}>
                                    {item.dateRegistration}
                                </Typography.Title>
                            </Flex>

                            <Typography.Paragraph
                                style={{ color: '#F41919', marginTop: 6, marginBottom: 3, fontSize: 14 }}
                            >
                                Подписка: {item.sum} ₽
                            </Typography.Paragraph>
                            <Typography.Paragraph
                                style={{ color: '#63C930', marginTop: 0, marginBottom: 3, fontSize: 14 }}
                            >
                                Вознаграждение: 500 р (50%)
                            </Typography.Paragraph>
                            <Typography.Paragraph
                                style={{ color: '#021728', marginTop: 0, marginBottom: 3, fontSize: 14 }}
                            >
                                https://lk.telegaplan.me/statistics
                            </Typography.Paragraph>
                        </Card>
                    )
                })}
            </Flex>
        )
    }

    return (
        <Flex vertical gap={'middle'} style={{ maxHeight: 'calc(100vh - 380px)', overflow: 'auto' }}>
            <Card style={{ backgroundColor: '#FFFFFF', width: '100%' }}>
                <Typography.Paragraph style={{ color: '#8F8E94', fontSize: 17, marginBottom: 10 }}>
                    Присвоить имя ссылке
                </Typography.Paragraph>
                <Flex vertical gap={17}>
                    <Input
                        style={{
                            padding: '13px 13px',
                            borderRadius: 12,
                            fontSize: 17,
                            color: '#8F8E94',
                            border: 'none'
                        }}
                        placeholder={'Telegaplan'}
                    />
                    <MobileButton>Добавить</MobileButton>
                </Flex>
            </Card>
            <Flex vertical gap={'small'}>
                <Typography.Text>Присвоить имя ссылке</Typography.Text>
                <Space>
                    <Input placeholder="Telegaplan" />
                    <Button type={'primary'}>Добавить</Button>
                </Space>
            </Flex>
            <Table<DataType> columns={columns} dataSource={data} />
        </Flex>
    )
}
